export default {
  roundtrip: {
    'roundtripOptions': 'Opciones de rutas circulares'
  }
}
